import XTbl,{Xtc} from '../../components/x-table/index';
// const tbl = new XTbl('/fund/history/query/', 'account');
const tbl = new XTbl('/bank-account/transactions/', 'account');

tbl.add(new Xtc('created_at', 'Date').renderSlot('date').noSort())
tbl.add(new Xtc('description', 'Source/Recipient').noSort())
tbl.add(new Xtc('ref_id', 'Reference Code').noSort())
tbl.add(new Xtc('id', 'Client').noSort().renderSlot('client'))
tbl.add(new Xtc('matter.title', 'Matter').noSort())
tbl.add(new Xtc('to_bank_account', 'Funds in').noSort().renderSlot('fund_in'))
tbl.add(new Xtc('from_bank_account', 'Funds out').noSort().renderSlot('fund_out'))
tbl.add(new Xtc('balance', 'Running Balance').noSort().renderSlot('running_balance'))

export default tbl;

